var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.toggle($event)}}}),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }